module.exports = __webpack_public_path__ + "static/media/login_scr_left.6cb41681.svg";